var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7416 6.55033V6.74199C23.6114 6.2563 23.3605 5.8114 23.0123 5.44863C22.6641 5.08586 22.2299 4.81699 21.7499 4.66699C19.8916 4.16699 12.4999 4.16699 12.4999 4.16699C12.4999 4.16699 5.14994 4.16699 3.33328 4.66699C2.83968 4.80199 2.38897 5.06134 2.02422 5.42026C1.65947 5.77917 1.39289 6.22564 1.24994 6.71699C0.545917 10.588 0.545917 14.5543 1.24994 18.4253V18.2337C1.37946 18.7278 1.63368 19.1804 1.98825 19.5481C2.34282 19.9158 2.78586 20.1863 3.27494 20.3337H3.33328C5.12494 20.8337 12.4999 20.8337 12.4999 20.8337C12.4999 20.8337 19.8666 20.8337 21.7166 20.3337C22.204 20.1954 22.6477 19.9342 23.0051 19.5753C23.3626 19.2163 23.622 18.7716 23.7583 18.2837C24.0875 16.4576 24.252 14.6058 24.2499 12.7503V12.3087C24.2494 10.3856 24.0737 8.46653 23.7249 6.57533L23.7416 6.55033ZM10.1583 16.0837V8.93366L16.2999 12.5003L10.1583 16.0837Z",
    fill: "#2B2F68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5a576f5c.svg";
export { ForwardRef as ReactComponent };